import React, { useState } from "react";
import { Plus } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/popover";
import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "../ui/command";
import { formatPrice } from "../../lib/matrix";

export default function AddonPicker({ addons, taken, symbol, onPick }) {
  const [open, setOpen] = useState(false);
  const options = addons.filter((a) => !taken.has(a.name.toLowerCase())).sort((a, b) => a.name.localeCompare(b.name));
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="tb-btn sm" data-testid="cost-add-addon">
          <Plus size={13} /> Add add-on product
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="p-0 w-[380px] addon-picker">
        <Command loop>
          <CommandInput placeholder="Search add-ons, e.g. Copilot" data-testid="cost-addon-search" />
          <CommandList className="max-h-72">
            <CommandEmpty>No add-on matches.</CommandEmpty>
            <CommandGroup heading={`${options.length} add-on products`}>
              {options.map((a) => (
                <CommandItem
                  key={a.name}
                  value={a.name}
                  onSelect={() => {
                    onPick(a.name);
                    setOpen(false);
                  }}
                  className="lookup-item"
                  data-testid="cost-addon-option"
                >
                  <span className="lookup-item-name">{a.name}</span>
                  <span className={`mono text-xs ${a.estimated ? "est" : ""}`}>
                    {a.price === null || a.price === undefined ? "\u2014" : formatPrice(a.price, symbol, a.estimated)}
                  </span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
